import React from 'react';
import { Col } from 'react-bootstrap';
import Questions from "./Questions";

class QuestionGroup extends React.Component {

	render() {
		if (this.props.group.name === "-") {
			return (
				<div className="row questionnaire__sections__section__groups__group">
					<Col lg={12}>
						<Questions
							group={this.props.group.id}
							fid={this.props.group.form}
							qsi={this.props.qsi}
							qgi={this.props.qgi}
							testObj={this.props.testObj}
						/>
					</Col>
				</div>
			)
		} else {
			return (
				<div className="row questionnaire__sections__section__groups__group">
					<Col lg={12}>
						<h4>{this.props.qsi}.{this.props.qgi}. {this.props.group.name}</h4>
						<Questions
							group={this.props.group.id}
							fid={this.props.group.form}
							qsi={this.props.qsi}
							qgi={this.props.qgi}
							testObj={this.props.testObj}
						/>
					</Col>
				</div>
			)
		}
	}
}

export default QuestionGroup;


// WEBPACK FOOTER //
// ./src/modules/form/view.1/QuestionGroup.js